<template>
    <div class="main-con">
      <table class="data-table">
        <thead>
        <tr>
            <th style="width: 1%" @click="sortOptionChange('rentalcompanyId','number')" class="width-pixel-50">임대업체ID</th>
            <th @click="sortOptionChange('accountId','number')" class="width-pixel-50">거래처ID</th>
            <th @click="sortOptionChange('accountName')" class="width-percent-14">거래처명</th>
            <th @click="sortOptionChange('accountBillDay','number')" class="width-pixel-50">거래처<br />결제일</th>
            <th @click="sortOptionChange('accountDeleteYn')" class="width-pixel-50">거래처<br />삭제여부</th>
            <th @click="sortOptionChange('billingId','number')" class="width-pixel-50">매출ID</th>
            <th @click="sortOptionChange('regType')" class="width-pixel-50">매출 유형</th>
            <th @click="sortOptionChange('autoFeeType')" class="width-pixel-50">생성 기준</th>
          <th @click="sortOptionChange('salesMonth')" class="width-pixel-70">매출월</th>
          <th @click="sortOptionChange('deleteYn')" class="width-pixel-50">매출<br />삭제여부</th>
          <th @click="sortOptionChange('item')" class="width-percent-14">품목명</th>
          <th @click="sortOptionChange('orgPrice','number')" class="width-percent-8">초기 금액</th>
          <th @click="sortOptionChange('reqPrice','number')" class="width-percent-8">요청 금액</th>
          <th @click="sortOptionChange('price','number')"  class="width-percent-8">남부 금액</th>
          <th @click="sortOptionChange('balance','number')" class="width-percent-8">잔액</th>
          <th @click="sortOptionChange('refdPrice','number')" class="width-percent-8">환불금액</th>
          <th @click="sortOptionChange('payMethod')" class="width-percent-6">남부방법명</th>
          <th @click="sortOptionChange('billDay','number')" class="width-pixel-50">매출<br />결제일</th>
          <th @click="sortOptionChange('printerContractId','number')"  class="width-pixel-50">프린터계약ID</th>
            <th @click="sortOptionChange('printerUsageSalesId','number')"  class="width-pixel-50">월사용량ID</th>
            <th @click="sortOptionChange('additionalWithdrawalId','number')" class="width-pixel-50">추가출금ID</th>
            <th @click="sortOptionChange('taxId','number')" class="width-pixel-50">세금계산서ID</th>
            <th @click="sortOptionChange('autoTaxType')" class="width-pixel-70">세금계산서<br />발행여부</th>
            <th @click="sortOptionChange('cmsMemberId','number')" class="width-percent-6">납부자번호</th>
            <th @click="sortOptionChange('register')" class="width-percent-6">등록자</th>
            <th @click="sortOptionChange('regDatetime')" class="width-percent-8">등록일시</th>
            <th @click="sortOptionChange('uptDatetime')" class="width-percent-8">수정일시</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in tableBodyData" :key="index" @click="()=>onWithdrawalModal(item)">
            <td class="table-text-center">{{ item.rentalcompanyId }}</td>
            <td class="table-text-center">{{ item.accountId }}</td>
            <td :title="item.accountName" class="column-size-short">{{ item.accountName }}</td>
            <td>{{ item.accountBillDay }}</td>
            <td class="table-text-center">{{ item.accountDeleteYn }}</td>
            <td>{{ item.billingId }}</td>
            <td class="table-text-center">{{ item.regType }}</td>
            <td class="table-text-center">{{ item.autoFeeType }}</td>
            <td>{{ item.salesMonth }}</td>
            <td class="table-text-center">{{ item.deleteYn }}</td>
            <td :title="item.item" class="column-size-short">{{ item.item }}</td>
            <td class="column-right-align">{{ numberFormat(item.orgPrice) }}</td>
            <td class="column-right-align">{{ numberFormat(item.reqPrice) }}</td>
            <td class="column-right-align">{{ numberFormat(item.price) }}</td>
            <td class="column-right-align">{{ numberFormat(item.balance) }}</td>
            <td class="column-right-align">{{ numberFormat(item.refdPrice) }}</td>
            <td>{{ item.payMethod }}</td>
            <td>{{ item.billDay }}</td>
            <td>{{ item.printerContractId }}</td>
            <td>{{ item.printerUsageSalesId }}</td>
            <td>{{ item.additionalWithdrawalId }}</td>
            <td>{{ item.taxId }}</td>
            <td class="table-text-center">{{ item.autoTaxType }}</td>
            <td>{{ item.cmsMemberId }}</td>
            <td :title="item.register" class="column-size-short">{{ item.register }}</td>
            <td>{{ dateFormatChange(item.regDatetime) }}</td>
            <td>{{ dateFormatChange(item.uptDatetime) }}</td>
        </tr>
        <v-btn
            :color="disableButton ? 'primary':'#cccccc'"
            dark
            large
            @click="plusLoadButtonClick"
            class="add-load-button"
        >
          추가로드
        </v-btn>
        </tbody>
      </table>
        <deposit-modal
            :dialog="dialog"
            :convey-data-deposit="conveyDataDeposit"
            @close-modal="closeSalesModal"
        />
    </div>

</template>

<script>
import {DateTime} from "luxon";
import DepositModal from "@/views/sales/DepositModal";

export default {
  name: "NoLibraryBagicTable",
  components: {
      DepositModal,
  },
  data() {
    return {
      sortOption: {
        sortName: null,
        sortOrder: 1,
      },
        dialog:false,
        conveyDataDeposit:{
            rentalcompanyId:undefined,
            accountId: undefined,
            billingId:undefined
        }
    }
  },
  props :{
    tableBodyData:{
      type:Array,
        default:()=>[]
    },
      disableButton:{
          type:Boolean,
          default:false
      },
      isPageSales:{ //메뉴에서 클릭시 true, 배치에서 모달로 나왔을때 false
        type:Boolean,
          default:false
      }
  },
  methods: {
      /**
       * 메뉴에서 매출 확인페이지를 클릭했을때만 적용됩니다.
       * 칼럽을 클릭하게되면 입출금 내역을 볼수있는 모달이 나옵니다.
       */
      onWithdrawalModal(item){
          if(!this.isPageSales) return
          this.conveyDataDeposit={
              rentalcompanyId:item.rentalcompanyId,
              accountId: item.accountId,
              billingId: item.billingId,
          }
          this.dialog = true
      },
      closeSalesModal() {
          this.dialog = false
      },
      /**
       * type이 date 인 cell은 Utc+9로 변경합니다
       * @param row
       * @returns {*}
       */
      dateFormatChange(date){
          if (!date) return undefined
          return DateTime.fromISO(DateTime.fromISO(date, {zone: 'utc'}).toISO()).toFormat("yyyy-MM-dd HH:mm")
      },

      /**
       * 돈과 연관되있는 데이터는 3번째 자리에서 ,를 찍어줍니다
       *
       * @param number
       * @returns {string}
       */
      numberFormat(number){
          if(!number) return '0'
          return number.toLocaleString()
      },
      /**
       * 추가로드 버튼을 클릭시 동작합니다.
       */
      plusLoadButtonClick() {
          if(!this.disableButton) return //데이터가 없을때 추가로드 비활성화 합니다.
          this.$emit('page-number-plus');
      },

      /**
       * header를 누를때 동작합니다.
       * 먼저 sortOption을 세팅하고 그에 맞게 sorting 해줍니다.
       * 숫자랑 문자 다 가능합니다.
       *
       */
      sortOptionChange(e,type) {
          this.setSortOption(e);
          this.$emit("sort-option-change",e,this.sortOption,type)
      },

    initSort(){
      this.sortOption = {
        sortName: null,
        sortOrder: 1,
      }
    },
    setSortOption(e) {
      if (e === this.sortOption.sortName){
        this.sortOption.sortOrder *= -1
      } else {
        this.sortOption = {
          sortName: e,
          sortOrder: 1,
        }
      }
    },


  }
}
</script>

<style scoped>

>>> input[type=checkbox] {
  position: absolute;
}

.main-con{
    height: 100%;
    overflow-y: auto;
}
.main-con .data-table{
    table-layout: fixed;
  border-spacing: 0;
    width: 140%;
    overflow-x: auto;
}
.main-con .data-table thead{
  position: sticky;
  top: 0;
  background: #ddd;
}
.main-con .data-table thead tr th {
  font-size: 11px;
    padding-right: 8px;
}

.main-con .data-table tbody td{
    text-align: left;
  border: 1px solid #ccc;
  font-size: 11px;
    padding: 0.15rem;
}

.main-con .data-table tbody tr:nth-child(even){
  background: #f5f5f5;
}
.main-con .data-table tbody tr:hover{
  background: #ddd;
}

.column-size-short{
    text-overflow:ellipsis;
    overflow:hidden;
    white-space:nowrap;
}
.width-pixel-50{
    width: 50px !important;
}
.width-pixel-70{
    width: 70px !important;
}
.width-pixel-100{
    width: 100px !important;
}
.width-percent-6{
    width: 6% !important;
}
.width-percent-8{
    width: 8% !important;
}
.width-percent-14{
    width: 14% !important;
}
.column-right-align{
    text-align: right !important;
}
.table-text-center{
    text-align: center !important;
}
</style>
